import Image from 'next/future/image';
import { useState } from 'react';
import sustainableIcon from '@/public/icons/collection/sustainable.svg';
import SustainableModal from './Modal';

const SustainableBadge = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        className="flex items-center gap-1.5 rounded-md bg-[#ECFCF5] px-3 py-1.5 text-xs text-[#1D6C49] focus:outline-none"
        onClick={() => setShowModal(true)}
      >
        <div className="h-3.5 w-3.5 shrink-0">
          <Image
            alt="Sustainable"
            src={sustainableIcon}
            className="h-full w-full"
          />
        </div>
        <div className="underline">
          <span className="xxs:hidden">Sustainable</span>
          <span className="hidden xxs:block">More sustainable than new</span>
        </div>
      </button>
      <SustainableModal
        showModal={showModal}
        hideModal={() => setShowModal(false)}
      />
    </>
  );
};

export default SustainableBadge;
